export var chipTheme = {
  baseStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    paddingY: 'xs',
    paddingX: 's',
    height: '40px',
    borderRadius: 'full',
    outlineColor: 'transparent',
    color: 'neutral.darkest',
    border: 'basic.dark',
    textStyle: 'body4Semi',
    transitionProperty: 'color, background-color',
    transition: '0.2s ease-in-out',
    _hover: {
      color: 'neutral.black',
      border: 'basic.darker'
    },
    _active: {
      color: 'neutral.black',
      border: 'basic.black'
    },
    _pressed: {
      backgroundColor: 'neutral.black',
      color: 'neutral.white',
      border: 'basic.black'
    },
    _focusVisible: {
      outlineStyle: 'solid',
      outlineWidth: '2px',
      outlineOffset: '2px',
      outlineColor: 'focus.focus',
      transition: 'outline-color 0.2s',
      border: 'surface.transparent'
    }
  }
};
//# sourceMappingURL=Chip.theme.js.map